import {
  useGetPageFromPath,
  useTrendsPageFilterState,
  useVisibleProcessIds,
} from "utils/customHooks/genericHooks";
import { DataDumpRowsGetterForSingleTimeline } from "./DataDumpRowsGetterForSingleTimeline";
import { useProcessIdOnTier0Page } from "components/MeritTier0Page/tier0Utils";
import { useDataDumpRows } from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";
import { useEffect } from "react";

export function DataDumpRowsGetter(): React.JSX.Element {
  const visibleProcessIds = useVisibleProcessIds();
  const { isTrendsPage, isTier0Page } = useGetPageFromPath();
  const { isTrendsPageFilteredByProcess, trendsPageFilterState } =
    useTrendsPageFilterState();

  const processIdTier0Page = useProcessIdOnTier0Page();
  const dataDumpProcessIds =
    isTrendsPage && isTrendsPageFilteredByProcess
      ? [trendsPageFilterState.process.id]
      : isTier0Page && processIdTier0Page
        ? [processIdTier0Page]
        : visibleProcessIds;

  const [, setDataDumpRows] = useDataDumpRows();

  // clear dataDumpRows when we unmount
  useEffect(() => {
    return () => {
      setDataDumpRows({});
    };
  }, [setDataDumpRows]);

  return (
    <>
      {dataDumpProcessIds.map(processId => (
        <DataDumpRowsGetterForSingleTimeline
          key={processId}
          {...{ processId }}
        />
      ))}
    </>
  );
}
